import { createApp } from "vue";
import store from "./store/store";
import AmenityApp from "./components/AmenityApp.vue";
import { i18n } from '../../i18n';

if (document.querySelector('#amenity_app')) {
  const app = createApp(AmenityApp);
  app.use(store)
  app.use(i18n);
  app.mount("#amenity_app");
}
